import { render, staticRenderFns } from "./GSalaryTicket.vue?vue&type=template&id=0219f5a2&"
import script from "./GSalaryTicket.vue?vue&type=script&lang=js&"
export * from "./GSalaryTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports